import { render, staticRenderFns } from "./FinishAllocationPopup.vue?vue&type=template&id=5576d247&"
import script from "./FinishAllocationPopup.vue?vue&type=script&lang=js&"
export * from "./FinishAllocationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5576d247')) {
      api.createRecord('5576d247', component.options)
    } else {
      api.reload('5576d247', component.options)
    }
    module.hot.accept("./FinishAllocationPopup.vue?vue&type=template&id=5576d247&", function () {
      api.rerender('5576d247', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/FinishAllocationPopup.vue"
export default component.exports